import * as React from "react"

// import { cn } from "@/lib/utils"

const Input = React.forwardRef<HTMLInputElement, React.ComponentProps<"input">>(
  ({ className, type, ...props }, ref) => {
    // Define base input class
    const baseClass = "input";
    
    // Combine with any additional classes
    const inputClass = [baseClass, className || ""].filter(Boolean).join(" ");
    
    return (
      <input
        type={type}
        className={inputClass}
        ref={ref}
        {...props}
      />
    )
  }
)
Input.displayName = "Input"

export { Input }
